<template>
  <v-navigation-drawer
    v-if="showToolbars"
    v-model="$store.state.menuDrawer"
    app
    dark
    temporary
    fixed
    clipped
    hide-overlay
    class="rai-app-sidenav"
  >
    <v-list
      nav
      subheader
    >
      <v-list-item class="px-0 ma-2">
        <v-list-item-avatar>
          <v-img src="@/assets/raison-logo-white.webp" />
        </v-list-item-avatar>

        <v-list-item-title>
          <div><v-img src="@/assets/raison-logo-name-full-white.webp" /></div>
          <div v-if="debugMode" class="rai-front-version">v{{ versionNumber }}</div>
        </v-list-item-title>

      </v-list-item>
      <div
      v-for="(item, index) in items"
      :key="index"
      >
        <v-divider   v-if="item.divider" />
        <v-subheader v-else-if="!item.route" class="overline rai-list-item">{{ item.title }}</v-subheader>
        <v-list-item v-else
          link
          class="pr-0"
          exact
          :to="item.route"
          :disabled="item.disabled"
        >
          <v-list-item-icon class="mr-1">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="overline rai-list-item">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>

      <v-list-item
        @click="logout"
        link
        exact
        class="pr-0"
      >
        <v-list-item-icon class="mr-1">
          <v-icon>mdi-power</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="overline rai-list-item">{{ $t('global.logout') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { Auth } from '@aws-amplify/auth';
import debugModeMixin from '@/mixins/debug-mode-mixin.js';
import userRightMixin from '@/mixins/user-rights-mixin.js';
import projectPageMixin from '@/mixins/project-page-mixin.js';
import { mapState } from 'vuex';

export default {
  name: "AppSidenav",

  components: { },

  mixins: [ userRightMixin, debugModeMixin, projectPageMixin ],

  data () {
    return {
      versionNumber: '',
    }
  },

  computed: {
    showToolbars () {
      const exlusions = ['/login', '/register']
      return !(exlusions.includes(this.$route.path))
    },
    items () {
      const projId = this.projectId ? this.projectId : '';
      let items = [
        { order: 1, title: this.$t('sidenav.projects'), icon: 'mdi-table-search', route: '/', disabled: false },
        { order: 5, title: this.$t('sidenav.editor'), icon: 'mdi-clipboard-edit-outline', route: '/projects/' + projId + '/editor', disabled: !this.isEditor(this.projectId) },
        { order: 15, title: this.$t('sidenav.play'), icon: 'mdi-play-box-outline', route: '/projects/' + projId + '/run', disabled: !this.projectId },
        { order: 20, title: this.$t('sidenav.developers'), icon: 'mdi-api', route: '/projects/' + projId + '/developer', disabled: !this.projectId },
        { divider: true },
        { order: 40, title: this.$t('sidenav.profile'), icon: 'mdi-account', route: '/profile', disabled: false },
      ];
      return items.sort((a, b) => a.order - b.order);
    },
    ...mapState(['project',]),
  },

  methods: {
    logout() {
      Auth.signOut().then(() => {
        this.$store.state.userInfo = null
        this.$store.state.menuDrawer = false
        this.$store.dispatch('logoutCognitoUser')
        this.$router.push({ name: 'login' })
        console.log('logout successfull')
      }).catch(err => {
        console.log('logout failed', err)
      }).finally(() => {
      })
    },
  },

  created () {
    this.versionNumber = process.env.VUE_APP_VERSION;
  },
};
</script>

<style scoped>
.rai-app-sidenav {
  background: rgb(163,239,237);
  background: linear-gradient(0deg, #00a19a 0%, #062b89 100%);
  /* margin-top: 64px; */
  z-index: 9;
}
.rai-front-version {
  color: #00a19a;
  font-size: 10px;
  position: absolute;
  /* bottom: 62px; */
  right: 5px;
  cursor: default;
  font-weight: bold;
}
.rai-list-item {
  flex: 1 1 100%;
  overflow-wrap: break-word;
  overflow: auto;
  text-overflow: ellipsis;
  white-space: initial;
}
.v-navigation-drawer--temporary.v-navigation-drawer--clipped {
    z-index: 5;
    padding-top: 64px;
}
</style>